export function ClearOutdatedStorage() {
    localStorage.removeItem("ticket");
    localStorage.removeItem("tickettext");
    localStorage.removeItem("selectedoffice");
    localStorage.removeItem("selectedqueuename");
    localStorage.removeItem("selectedqueue");
    localStorage.removeItem("queueid");
    localStorage.removeItem("formname");
    localStorage.removeItem("isBooking");
    sessionStorage.removeItem("queuename");
    sessionStorage.removeItem("formdata");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("tokenconfig");
}